import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import Badge from '../../ui/common/Badge';
import {Badge as BadgeType, BadgeClassName} from '../type';

interface Props extends BadgeClassName {
  badges?: BadgeType[];
  className?: string;
  badgeClassName?: string;
  isBig?: boolean;
  children?: ReactNode;
}

export default function BadgeList({
  badges = [],
  className,
  badgeClassName,
  isBig,
  children,
  customTypeClassName,
  variantTypeClassName,
  imgTypeClassName,
  imgTextTypeClassName,
}: Props) {
  const {t} = useTranslation();
  return (
    <>
      {badges.length > 0 && (
        <div className={cn('w-full leading-[0px]', className)}>
          {badges.map((badge, index) => (
            <Badge
              key={index}
              className={badgeClassName}
              {...badge}
              label={t(badge.label)}
              isBig={isBig}
              customTypeClassName={customTypeClassName}
              variantTypeClassName={variantTypeClassName}
              imgTypeClassName={imgTypeClassName}
              imgTextTypeClassName={imgTextTypeClassName}
            />
          ))}
          {children}
        </div>
      )}
    </>
  );
}
